import { Client } from '@stomp/stompjs';
import SockJS from 'sockjs-client';

const connectWebSocket = (url, onMessageReceived) => {
    const client = new Client({
        brokerURL: 'wss://' + process.env.REACT_APP_URL.replace('https://', '') + 'ws',
        webSocketFactory: () => new SockJS(process.env.REACT_APP_URL + 'ws'),
        reconnectDelay: 5000,
        // Los topics del admin exigen el token en el CONNECT. Se lee en cada conexión
        // para que las reconexiones usen el token renovado
        beforeConnect: () => {
            const token = localStorage.getItem(process.env.REACT_APP_TOKEN);
            client.connectHeaders = token ? { Authorization: `Bearer ${token}` } : {};
        },
        onConnect: () => {
            client.subscribe(`/topic/${url}`, (message) => {
                try {
                    const parsed = JSON.parse(message.body);
                    onMessageReceived(parsed);
                } catch (e) {
                    console.warn("Mensaje no es JSON, se envía como texto plano");
                    onMessageReceived(message.body);
                }
            });
        },
        onStompError: (error) => {
            //console.error('WebSocket error', error);
        },
    });
    client.activate();
    return client;
};

export default connectWebSocket;
